<template>
  <a-modal
    title="安排面试"
    :confirmLoading="loading"
    :destroyOnClose="true"
    v-model="visible"
    @ok="handleOk"
    @cancel="close"
  >
    <a-form :form="form">
      <a-form-item label="面试类型" v-bind="formItemsLayout">
        <a-select
          @change="handleTypeChange"
          v-decorator="[
            'type',
            { rules: [{ required: true, message: '请设置面试类型' }] }
          ]"
        >
          <a-select-option value="INTERVIEW">面试</a-select-option>
          <a-select-option value="PEN">笔试</a-select-option>
          <a-select-option value="VIDEO">视频</a-select-option>
          <a-select-option value="TEL">电话</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="面试时间" v-bind="formItemsLayout">
        <a-date-picker
          format="YYYY-MM-DD HH:mm"
          showTime
          style="display:block;width:100%;"
          v-decorator="[
            'time',
            { rules: [{ required: true, message: '请设置面试时间' }] }
          ]"
        ></a-date-picker>
      </a-form-item>
      <a-form-item label="面试地点" v-bind="formItemsLayout" v-if="showAddr">
        <a-input
          v-decorator="[
            'address',
            { rules: [{ required: true, message: '请设置面试地点' }] }
          ]"
        />
      </a-form-item>
      <a-form-item label="上传附件" v-bind="formItemsLayout" v-if="showFirst">
          <a-upload
            name="file"
            :multiple="true"
            accept=".pdf,.doc,.docx,image/jpeg,image/jpg,image/png,.zip,.rar"
            :action="baseURL + '/common/file/upload'"
            :data="{ token: token }"
              v-decorator="[
              'attachment',
              {
                getValueFromEvent: normFile,
                rules: [{ required: true, message: '请上传沟通附件'}]
              }
            ]"
          >
            <a-button>
              <a-icon type="link" /> 点击上传沟通记录
            </a-button>
          </a-upload>
        </a-form-item>
      <a-form-item label="附言" v-bind="formItemsLayout">
        <a-textarea :rows="6" v-decorator="['remark']"></a-textarea>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import Api from "@/api";
let baseURL = process.env.VUE_APP_BASEURL;
import { mapState } from "vuex";

export default {
  name: "ArrangeInterviewModal",
  data() {
    return {
      record: {},
      baseURL: baseURL,
      visible: false,
      file:[],
      loading: false,
      showAddr: true,
      attachment: [],
      showFirst: false,
      form: this.$form.createForm(this),
      formItemsLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 16 }
      }
    };
  },
  computed: {
    ...mapState(["token"])
  },
  methods: {
    show(record) {
      this.visible = true;
      this.record = record;
      this.$nextTick().then(() => {
        if(record.status_origin === '3') {
        this.showFirst = true
      } else {
        this.showFirst = false
      }
        this.showAddr = true;
        this.form.setFieldsValue({
          type: "INTERVIEW"
        });
      });
    },
    close() {
      this.visible = false;
    },
    normFile(info) {
      console.log("Upload event:", info);
      if (Array.isArray(info)) {
        return info;
      }
      const status = info.file.status;
      this.fileList = info.fileList
      console.log(this.fileList )
      if (status === "done") {
        this.$message.success(`${info.file.name} 上传成功！`);
        this.file = [];
        info.fileList.forEach(item => {
          if (item.response && item.response.data) {
            this.file.push(item.response.data);
          }
        });
      } else if (status === "error") {
        this.$message.error(`${info.file.name} 上传失败！`);
      }
      return info && info.fileList;
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true;
          for(var i = 0;i< this.fileList.length;i++) {
            this.attachment.push({url:this.fileList[i].response.data.url,name:this.fileList[i].response.data.name,time:this.fileList[i].response.data.time})
          }
          return new Promise(async (resolve, reject) => {
            try {
              await Api.order.arrangeInterview({
                ...values,
                time: values.time.format("YYYY-MM-DD HH:mm"),
                attachment: this.attachment,
                post_id: this.record.id
              });
            } catch (e) {}
            resolve();
            this.loading = false;
            this.close();
            this.$emit("ok");
          });
        }
      });
    },
    handleTypeChange(val) {
      this.showAddr = val === "INTERVIEW" ? true : false;
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep.ant-upload-list-item-info {
  height: 100%;
    padding: 0 30px 0 4px;
    -webkit-transition: background-color 0.3s;
    transition: background-color 0.3s;
}
::v-deep.ant-upload-list-item-card-actions {
    position: absolute;
    right: 0;
    opacity: 1;
}
::v-deepa {
  display: inline-block;
    width: 30px;
    text-align: center;
}
</style>
